import moment, { Moment } from 'moment';

export const utcMoment = (inp?: any, doNotKeepLocalTime?: boolean): Moment => {
  return moment(inp).utc(!doNotKeepLocalTime);
};
